import { shouldPolyfill } from "@formatjs/intl-locale/should-polyfill";

// Fire-and-forget: keep this file free of top-level await so it can be bundled
// against older ES targets. Safe because Intl.Locale is only consumed after app
// boot, by which point the dynamic import has resolved.
if (shouldPolyfill()) {
  void import("@formatjs/intl-locale/polyfill");
}
